module.exports = __webpack_public_path__ + "img/economic-cars.bdec86a3.jpeg";